var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-inner-loading',{staticStyle:{"z-index":"5000"},attrs:{"showing":_vm.loading}},[_c('q-spinner',{attrs:{"color":"primary","size":"3em"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }